import React from 'react';
import ReactDOM from 'react-dom';

interface PortalProps {
  children?: React.ReactNode | React.ReactNode[];
}

const Portal = ({ children }: PortalProps) => {
  return ReactDOM.createPortal(children, document.getElementById('modal-root'));
};

export default Portal;
